"use strict";
/**
 * **The write cycle back into QVET, as the screens see it.** GH527 · SP8 §3quater.
 *
 * The four class-C entities — articles, warehouses, sections and suppliers — all write back
 * through the same three steps, and each step has a shape a screen has to render:
 *
 * | Step | Route | What comes back |
 * |---|---|---|
 * | **propose** | `PATCH /:qvetId` | {@link QvetStageResult} — what got staged, what QVET already said, what was refused |
 * | **push** | `POST /:qvetId/push-to-qvet` | {@link QvetWriteResult} — one {@link QvetFieldOutcome} per field |
 * | **withdraw** | `POST /:qvetId/clear-pending` | {@link QvetClearPendingResult} |
 *
 * These lived only in the backend until 2026-09-12, which is why the first screen had nowhere
 * to import them from. They are API responses, so they belong here: a screen that re-declares
 * them locally is a screen that keeps rendering the old shape after the engine changes.
 */
Object.defineProperty(exports, "__esModule", { value: true });
